module.exports = __webpack_public_path__ + "img/paysage-urbain.efd258b0.svg";